import { createStyles, makeStyles } from '@hawkins/styles';
import { COLLAPSE_ANIMATION_DURATION, COLLAPSE_ANIMATION_TIMING_FN } from '../transitions/collapse.styles';
export function accordionStyles(theme) {
    var hawkins = theme.hawkins;
    return createStyles({
        /** Class name of the element containing the collapsible content. */
        collapsiblePanel: {
            flexGrow: 1,
        },
        /** Class name of the root element. */
        root: {
            backgroundColor: hawkins.ui.backgroundColor0,
            borderBottomColor: 'transparent',
            borderBottomStyle: 'solid',
            borderBottomWidth: 0,
            display: 'flex',
            flexDirection: 'column',
            transition: "border-bottom-color ".concat(COLLAPSE_ANIMATION_DURATION, "ms ").concat(COLLAPSE_ANIMATION_TIMING_FN),
        },
        /** Class name of the root element when the component is expanded. */
        rootDisabled: {},
        /** Class name of the root element when the component is expanded. */
        rootExpanded: {
            borderBottomColor: hawkins.ui.borderColorXlight,
            borderBottomWidth: hawkins.ui.borderWidthRegular,
        },
        /** Class name of the root element when the component is full-height. */
        rootFullHeight: {
            height: '100%',
        },
    });
}
export var useAccordionStyles = makeStyles(accordionStyles, { name: 'Hawkins-Accordion' });
